import {
  Avatar,
  CollapseCard,
  FlexBox,
  IconButton,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { Conversation, MetaConversation } from 'lib-shared-legacy-types';
import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { appActions } from 'app/app.actions';
import {
  ConversationDetails,
  ConversationDetailsLayout,
} from 'components/conversation/conversationDetails';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import styles from './historyCardItem.module.scss';

type HistoryCardItemProps = {
  conversation: Conversation;
  handleOnConversationLinkClick: () => void;
  renderTitle: ({
    metaConversation,
  }: {
    metaConversation: MetaConversation;
  }) => JSX.Element;
};

export const HistoryCardItem = memo(function HistoryCardItem({
  conversation,
  handleOnConversationLinkClick,
  renderTitle,
}: HistoryCardItemProps): JSX.Element {
  const dispatch = useAppDispatch();

  const handlePreviewIconClick = useCallback(
    (event: React.MouseEvent): void => {
      if (!conversation.id) {
        return;
      }

      event.preventDefault();

      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:conversationPreview',
            arg: { csid: conversation.id },
          },
        }),
      );
    },
    [conversation, dispatch],
  );

  return (
    <Link
      to={`/conversation/${conversation.id}`}
      onClick={handleOnConversationLinkClick}
    >
      <CollapseCard.Line className={styles.line}>
        <FlexBox alignItems="center" justifyContent="space-between">
          <FlexBox alignItems="center" gap="100" minWidth="0">
            <Tooltip dark content="Preview">
              <IconButton
                icon="eye"
                variant="tertiary"
                onClick={handlePreviewIconClick}
              />
            </Tooltip>

            <ConversationDetails
              layout={ConversationDetailsLayout.ConversationHistory}
              showRequesterAvatar={false}
              conversationName={null}
              metaConversation={metaConversation.from.conversation(
                conversation,
              )}
              titleRenderer={renderTitle}
            />
          </FlexBox>

          <Tooltip
            dark
            content={
              conversation.assignment?.agent
                ? `Assigned to ${conversation.assignment.agent.name}`
                : 'Unassigned'
            }
          >
            <Avatar user={conversation.assignment?.agent ?? null} />
          </Tooltip>
        </FlexBox>
      </CollapseCard.Line>
    </Link>
  );
});
